import { BACKEND_URL_PREFIX, itemsPerPage } from "../utils/const";
import {
  NETWORK_REQUEST_SENT,
  DISCIPLINE_FETCH_COMPLETED,
  ALL_DISCIPLINES_FETCH_STARTED,
  ALL_DISCIPLINES_FETCH_COMPLETED,
  DISCIPLINE_FETCH_STARTED,
  FETCH_DISCIPLINES_BY_TERM_FETCH_START,
  FETCH_DISCIPLINES_BY_TERM_FETCH_COMPLETED,
  FETCH_DISCIPLINE_EDUCATION_START,
  FETCH_DISCIPLINE_EDUCATION_COMPLETED,
  FETCH_COMPLEX_THEME_PLAN_STREAM_FETCH_START,
  FETCH_COMPLEX_THEME_PLAN_STREAM_FETCH_COMPLETED,
  FETCH_COMPLEX_THEME_PLAN_STREAM_FETCH_FAILED,
  COMPLEX_THEME_PLAN_STREAM_CLEAR,
  COMPLEX_TOPICS_DISCIPLINES_SET_CURRENT,
  COMPLEX_THEME_PLAN_STREAM_CURRENT_FETCH_STARTED,
  COMPLEX_THEME_PLAN_STREAM_CURRENT_FETCH_ERROR,
  FETCH_CIRRICULUM_BY_CATHEDRA_START,
  FETCH_CIRRICULUM_BY_CATHEDRA_COMPLETED,
  FETCH_CIRRICULUM_BY_CATHEDRA_FAILED,
  SET_DISCIPLINE_MORE_INFO,
  FETCH_DISCIPLINES_BY_TERM_FETCH_COMPLETEDBYPARAMS
} from "./types";
import { buildDefaultHeaders } from "./helper";
import { checkAndUpdateToken } from "./auth";
import { saveBlobAsFile } from "../utils/blob";

export const discipline = (params) => async (dispatch, getState) => {

  await dispatch(checkAndUpdateToken());
  if (getState().auth.token) {
    dispatch({ type: DISCIPLINE_FETCH_STARTED });
    const response = await fetch(
      `${BACKEND_URL_PREFIX}/umk/course/${params.cid}/${params.idcurriculum}/${params.syid}/${params.eyid}`,
      buildDefaultHeaders(getState)
    );

    dispatch({ type: NETWORK_REQUEST_SENT, response });

    if (response.ok) {
      const data = await response.json();
      await dispatch({
        type: DISCIPLINE_FETCH_COMPLETED,
        // disciplineDetails: Object.keys(data.umkTree).reduce(
        //   (c, k) => c.concat(data.umkTree[k]),
        //   []
        // ),
        disciplineDetails: data.umkCourseDetails,
        commonFiles: data.commonFiles,
        idCurriculum: data.id_curriculum_course,
        educationYearId: params.eyid,
        ccId: data.id_curriculum_course
      });
    }
  }
};

export const allDisciplines = () => async (dispatch, getState) => {
  await dispatch(checkAndUpdateToken());
  if (getState().auth.token) {
    dispatch({ type: ALL_DISCIPLINES_FETCH_STARTED });
    const response = await fetch(
      `${BACKEND_URL_PREFIX}/course`,
      buildDefaultHeaders(getState)
    );

    dispatch({ type: NETWORK_REQUEST_SENT });

    if (response.ok) {
      const data = await response.json();
      dispatch({ type: ALL_DISCIPLINES_FETCH_COMPLETED, disciplines: data });
    }
  }
};
// всё работает == 404 
export const disciplinesByTerm = (termId) => async (dispatch, getState) => {
  await dispatch(checkAndUpdateToken());
  if (getState().auth.token) {
    dispatch({ type: FETCH_DISCIPLINES_BY_TERM_FETCH_START });

    const response = await fetch(
      `${BACKEND_URL_PREFIX}/course/student/${termId}`,
      buildDefaultHeaders(getState)
    );

    dispatch({ type: NETWORK_REQUEST_SENT });

    if (response.ok) {
      const data = await response.json();
      dispatch({
        type: FETCH_DISCIPLINES_BY_TERM_FETCH_COMPLETED,
        disciplinesByTerm: data,
      });
    } else {
      dispatch({ type: FETCH_DISCIPLINES_BY_TERM_FETCH_COMPLETED, disciplinesByTerm: [] });
    }
  }
};

export const fetchDisciplinesByParams = (params) => async (dispatch, getState) => {
  await dispatch(checkAndUpdateToken());

  const token = getState().auth.token;
  if (!token) return;

  dispatch({ type: FETCH_DISCIPLINES_BY_TERM_FETCH_START });

  // Очистка от пустых значений
  const filteredParams = Object.entries(params || {})
    .filter(([_, value]) => value !== '' && value !== null && value !== undefined)
    .reduce((acc, [key, value]) => {
      acc[key] = value;
      return acc;
    }, {});

  const queryString = new URLSearchParams(filteredParams).toString();

  try {
    const response = await fetch(
      `${BACKEND_URL_PREFIX}/students_projects/course?${queryString}`,
      buildDefaultHeaders(getState)
    );

    dispatch({ type: NETWORK_REQUEST_SENT });

    if (response.ok) {
      const data = await response.json();
      dispatch({
        type: FETCH_DISCIPLINES_BY_TERM_FETCH_COMPLETEDBYPARAMS,
        disciplinesByTerms: data,
      });
    } else {
      // Можно добавить обработку ошибок здесь
      dispatch({
        type: FETCH_DISCIPLINES_BY_TERM_FETCH_COMPLETEDBYPARAMS,
        disciplinesByTerms: [],
      });
      console.error('Ошибка при получении дисциплин:', response.statusText);
    }
  } catch (error) {
    dispatch({
        type: FETCH_DISCIPLINES_BY_TERM_FETCH_COMPLETEDBYPARAMS,
        disciplinesByTerms: [],
      });
    console.error('Ошибка при fetchDisciplinesByParams:', error);
  }
};


export const fetchCirriculumByCafedra = (cathedraId = 0) => async (dispatch, getState) => {
  await dispatch(checkAndUpdateToken());
  if (getState().auth.token) {
    dispatch({ type: FETCH_CIRRICULUM_BY_CATHEDRA_START });
    const response = await fetch(
      `${BACKEND_URL_PREFIX}/curriculum_by_cathedra/${cathedraId}`,
      buildDefaultHeaders(getState)
    );
    dispatch({ type: NETWORK_REQUEST_SENT, response });
    if (response.ok) {
      const data = await response.json();
      await dispatch({ type: FETCH_CIRRICULUM_BY_CATHEDRA_COMPLETED, plansByCathedra: data });
    } else {
      await dispatch({ type: FETCH_CIRRICULUM_BY_CATHEDRA_FAILED, plansByCathedra: [] });
    }
  }
};

export const getComplexThemePlanStream = (xp_key = 0, idcathedra = 0, idcurriculum = 0, cid = 0, page = 0) => async (dispatch, getState) => {
  await dispatch(checkAndUpdateToken());
  if (!getState().auth.token) return;

  const limit = itemsPerPage;
  const offset = page * itemsPerPage;

  const params = new URLSearchParams({
    xp_key,
    idcathedra,
    idcurriculum,
    cid,
    limit,
    offset,
  });

  dispatch({ type: FETCH_COMPLEX_THEME_PLAN_STREAM_FETCH_START });

  try {
    const response = await fetch(
      `${BACKEND_URL_PREFIX}/plans/complex_theme_plan_stream?${params}`,
      buildDefaultHeaders(getState)
    );

    if (response.ok) {
      dispatch({
        type: FETCH_COMPLEX_THEME_PLAN_STREAM_FETCH_COMPLETED,
        complexData: await response.json(),
      });
    } else {
      dispatch({
        type: FETCH_COMPLEX_THEME_PLAN_STREAM_FETCH_FAILED,
        errorStatus: response.status,
      });
    }
  } catch (error) {
    dispatch({
      type: FETCH_COMPLEX_THEME_PLAN_STREAM_FETCH_FAILED,
      errorStatus: 0,
    });
  }
};

export const getComplexThemePlanCurrent = (id) => async (dispatch, getState) => {
  await dispatch(checkAndUpdateToken());
  if (!getState().auth.token) return;

  dispatch({ type: COMPLEX_THEME_PLAN_STREAM_CURRENT_FETCH_STARTED });

  try {
    const response = await fetch(
      `${BACKEND_URL_PREFIX}/plans/complex_theme_plan_stream/${id}`,
      buildDefaultHeaders(getState)
    );

    if (response.ok) {
      dispatch({
        type: COMPLEX_TOPICS_DISCIPLINES_SET_CURRENT,
        payload: await response.json(),
      });
    } else {
      dispatch({
        type: COMPLEX_THEME_PLAN_STREAM_CURRENT_FETCH_ERROR,
        errorStatus: response.status,
      });
    }
  } catch (error) {
    dispatch({
      type: COMPLEX_THEME_PLAN_STREAM_CURRENT_FETCH_ERROR,
      errorStatus: 0,
    });
  }
};

export const clearComplexThemePlanCurrent = () => ({
  type: COMPLEX_TOPICS_DISCIPLINES_SET_CURRENT,
  payload: null,
});

export const clearComplexThemePlanStream = () => ({ type: COMPLEX_THEME_PLAN_STREAM_CLEAR });

export const file = (idCurriculum, eyId, tlid, oid, filename) => async (
  dispatch,
  getState
) => {
  await dispatch(checkAndUpdateToken());
  if (getState().auth.token) {
    const response = await fetch(
      `${BACKEND_URL_PREFIX}/umk/course/files/${idCurriculum}/${eyId}/${tlid}/${oid}/${filename}`,
      buildDefaultHeaders(getState)
    );
    dispatch({ type: NETWORK_REQUEST_SENT, response });
    if (response.ok) {
      const data = await response.blob();
      // eslint-disable-next-line
      const fileDownload = require("js-file-download");
      fileDownload(data, filename);
    }
  }
};


export const lessonsFile = (
  lesson_id, filename
) => async (dispatch, getState) => {
  const response = await fetch(
    `${BACKEND_URL_PREFIX}/umk/course/lesson/student/${lesson_id}/${filename}`,
    buildDefaultHeaders(getState)
  );

  dispatch({ type: NETWORK_REQUEST_SENT, response });

  if (response.ok) {
    const data = await response.blob();
    const fileDownload = require("js-file-download");
    fileDownload(data, filename);
  }
};

export const getMoreInfo = (currId, cid) => async (dispatch, getState) => {
  await dispatch(checkAndUpdateToken());
  if (getState().auth.token) {
    const response = await fetch(
      `${BACKEND_URL_PREFIX}/umk_links/${currId}/${cid}`,
      buildDefaultHeaders(getState)
    );
    if (response.ok) {
      const payload = await response.json();
      dispatch({ type: SET_DISCIPLINE_MORE_INFO, payload });
    }
  }
};

export const getFile = (id, fileName) => async (dispatch, getState) => {
  const response = await fetch(
    `${BACKEND_URL_PREFIX}/umk/file/${id}`,
    buildDefaultHeaders(getState)
  );
  if (response.ok) {
    const blob = await response.blob();
    saveBlobAsFile(blob, fileName);
  }
};